import { Component, OnInit, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { CookieService } from 'ngx-cookie-service';
import { CommonEnum } from '../../../shared/enums/common.enum';
import { NotificationService } from '../../../shared/services/notification.service';
import { isNullOrUndefined } from 'is-what';
import { environment } from '../../../../environments/environment';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrl: './container.component.scss',
})
export class ContainerComponent implements OnInit {
  private translocoService = inject(TranslocoService);
  private cookieService = inject(CookieService);
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);

  notificationService = inject(NotificationService);
  isLoad = false;

  changeLanguage(lang: string): void {
    if (isNullOrUndefined(lang) || lang === '') {
      lang = environment.defaultLang;
    }
    this.translocoService.setActiveLang(lang);
    this.cookieService.set(CommonEnum.Language, lang, {
      expires: 10,
      secure: true,
    });
  }

  ngOnInit() {
    const token: string = this.authenticationService.getToken();
    if (token === '') {
      this.router.navigateByUrl('/login');
    } else {
      this.isLoad = true;
    }
    const lang = this.cookieService.get(CommonEnum.Language);
    if (lang) {
      this.translocoService.setActiveLang(lang);
    }
  }
}
